import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { DOWNLOAD_API } from '@/api'
import { Checkbox } from '@/components/core-v2'
import { DownloadLink, onDownloadLinkClick } from '@/components/core-v2/molecules/download-link'
import { plural } from '@/utilities/plural'

import { useFilteredGetByTenantAccountDashboardQuery } from '../../utils/useFilteredNotes'
import { NoteCard } from '../note-card'
import classes from './index.module.scss'

export const NotesMaster = () => {
  const { data, isError, isLoading } = useFilteredGetByTenantAccountDashboardQuery()

  const [checkedNoteIds, setCheckedNoteIds] = useState(new Set<string>())
  const checkedAmount = checkedNoteIds.size

  const { noteId } = useParams()

  if (isError || isLoading) return null

  const notes = data.notes.filter(note => note.noteName !== 'Dominion')
  const allNoteIds = new Set(notes.map(n => n.noteId))
  const isAllNotesChecked = checkedNoteIds.size === notes.length
  const isSomeNotesChecked = checkedNoteIds.size > 0 && !isAllNotesChecked

  return (
    <section>
      <div className={classes.root}>
        <span>Export reports</span>
        {checkedAmount ? (
          <DownloadLink
            className="mr-4"
            onClick={() =>
              onDownloadLinkClick({
                url: DOWNLOAD_API.exportLiveStatementsForMultipleNotes(Array.from(checkedNoteIds))
              })
            }
          >
            Export {checkedAmount} note {plural('statement', checkedAmount)}
          </DownloadLink>
        ) : undefined}
        <Checkbox
          aria-label="Select or deselect all notes"
          checked={isAllNotesChecked}
          halfChecked={isSomeNotesChecked}
          onChange={() => {
            if (isAllNotesChecked) {
              setCheckedNoteIds(new Set())
            } else {
              setCheckedNoteIds(allNoteIds)
            }
          }}
        />
      </div>
      <ul className={classes.list}>
        {notes.map(note => (
          <NoteCard
            {...note}
            key={note.noteId}
            isChecked={checkedNoteIds.has(note.noteId)}
            isSelected={note.noteId === noteId}
            setCheckedNoteIds={setCheckedNoteIds}
          />
        ))}
      </ul>
    </section>
  )
}
